// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__iICw7","innerContainer":"Footer_innerContainer__ac2ij","imageContainer":"Footer_imageContainer__1m2kj","image":"Footer_image__TYsH2"};